export default __webpack_public_path__ + "static/media/thnakyou1.7a6d0f13.jpg";